import React, { useState, useEffect, memo } from "react";
import { Text, View, Page, Document, PDFViewer } from '@react-pdf/renderer';
import { getInspectors, getOrganizations } from "../../api/index.js";
import Spinner from "../../components/Spinner.js";
import "../../components/pdf/Fonts.js"
import styles from "../../components/pdf/Styles.js"

const InspectorsPdf = () => {
    const [inspectors, setInspectors] = useState([]);
    const [organizations, setOrganizations] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const fetchData = async () => {
        setIsLoading(true);
        const { inspectors } = await getInspectors();
        setInspectors(inspectors);

        const { organizations } = await getOrganizations();
        setOrganizations(organizations);
        setIsLoading(false);

    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <>
            <Spinner open={isLoading} />
            <PDFViewer style={{ width: '99%', height: '100vh' }}>
                <Document>
                    <Page size='A4' orientation='landscape' style={styles.page} wrap>
                        <View style={styles.topColumn} fixed>
                            <View style={styles.headers_container}>
                                <Text style={styles.headers}>{'Επώνυμο'}</Text>
                                <Text style={styles.headers}>{'Όνομα'}</Text>
                                <Text style={styles.headers}>{'Διεύθ.'}</Text>
                                <Text style={styles.headers}>{'Πόλη'}</Text>
                                <Text style={styles.headers}>{'Τ.Κ.'}</Text>
                                <Text style={styles.headers}>{'Σταθερό'}</Text>
                                <Text style={styles.headers}>{'Κινητό'}</Text>
                                <Text style={styles.headers}>{'Οργάνωση'}</Text>
                            </View>
                        </View>
                        <View style={styles.bottomColumns}>
                            {inspectors.map((item) =>
                                <View key={item._id} style={styles.cells_container} wrap={false}>
                                    <Text style={styles.cell}>{item.lastName}</Text>
                                    <Text style={styles.cell}>{item.firstName}</Text>
                                    <Text style={styles.cell}>{item.address}</Text>
                                    <Text style={styles.cell}>{item.city}</Text>
                                    <Text style={styles.cell}>{item.postalCode}</Text>
                                    <Text style={styles.cell}>{item.phoneNumber}</Text>
                                    <Text style={styles.cell}>{item.cellPhone}</Text>
                                    <Text style={[styles.cell, { fontSize: '6px' }]}>{
                                        organizations.find((organization) => organization._id === item.organization)?.name
                                    }</Text>
                                </View>
                            )}
                        </View>
                    </Page>
                </Document>
            </PDFViewer>
        </>
    );
};

export default memo(InspectorsPdf);
